import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import GlobalSearcher, {
  Filter,
} from '../../../../../../../../../lib/common/GlobalSearcher';
import AlertBanner from '../../../../../../../../../lib/designSystem/AlertBanner';
import CustomButton from '../../../../../../../../../lib/designSystem/Button';
import HeaderWithActions from '../../../../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../../../../lib/designSystem/Table';
import { cellFormat } from '../../../../../../../../../lib/designSystem/Table/cellFormat';
import { showAlert } from '../../../../../../../../../lib/functions/utils';
const MAX_SELECTED_DOCUMENTS = 75;
const MultiResellDocumentSelector = (props: any) => {
  const { suggestions, documents, setDocuments, handleConfirm, open, setOpen } =
    props;
  const [filteredSuggestions, setFilteredSuggestions] = useState<any>([]);
  const dispatch = useDispatch();
  // Filters
  const [filteredDocuments, setFilteredDocuments] =
    useState<any[]>(suggestions);
  const [searchStakeholder, setSearchStakeholder] = useState('all');
  const [searchBusiness, setSearchBusiness] = useState('all');
  const [searchFolio, setSearchFolio] = useState('');
  const [searchFactoringRequestId, setSearchFactoringRequestId] = useState('');

  const handleChange = (event: any, newValue: any) => {
    if (!newValue) return setFilteredSuggestions(suggestions);
    const filtered = suggestions.filter((x: any) => x.id === newValue.id);
    setFilteredSuggestions(filtered);
  };

  const autoCompleteFilter = (
    <Autocomplete
      options={suggestions}
      getOptionLabel={(option: any) =>
        `${cellFormat(option.factoringRequestId, 'numeric-id')} | ${cellFormat(option.folio, 'number')} | ${cellFormat(option.businessName, 'text')} | ${cellFormat(option.stakeholderName, 'text')}`
      }
      renderInput={(params) => (
        <TextField style={{ minWidth: 250 }} {...params} label="Filtrar" />
      )}
      onChange={handleChange}
      fullWidth
    />
  );

  const filters: Filter[] = [
    {
      type: 'select',
      label: 'Deudor',
      options: [
        { value: 'all', label: 'Todos' },
        ...suggestions
          .map((document: any) => ({
            value: document.stakeholderIdentifier,
            label: `${document.stakeholderName} - ${document.stakeholderIdentifier}`,
          }))
          .filter(
            (value: any, index: any, self: any) =>
              self.findIndex((t: any) => t.value === value.value) === index,
          )
          .sort((a: any, b: any) => a.label.localeCompare(b.label)),
      ],
      value: searchStakeholder,
      setter: setSearchStakeholder,
    },
    {
      type: 'select',
      label: 'Cliente',
      options: [
        { value: 'all', label: 'Todos' },
        ...suggestions
          .map((document: any) => ({
            value: document.businessIdentifier,
            label: `${document.businessName} - ${document.businessIdentifier}`,
          }))
          .filter(
            (value: any, index: any, self: any) =>
              self.findIndex((t: any) => t.value === value.value) === index,
          )
          .sort((a: any, b: any) => a.label.localeCompare(b.label)),
      ],
      value: searchBusiness,
      setter: setSearchBusiness,
    },
    {
      type: 'text',
      label: 'Folio',
      value: searchFolio,
      setter: setSearchFolio,
    },
    {
      type: 'text',
      label: 'Solicitud',
      value: searchFactoringRequestId,
      setter: setSearchFactoringRequestId,
      specialHandler: 'id',
    },
  ];

  const filterDocuments = async () => {
    const newFilteredDocuments = suggestions?.filter((document: any) => {
      const isStakeholderMatch =
        searchStakeholder == 'all' ||
        document.stakeholderIdentifier == searchStakeholder;
      const isFolioMatch = searchFolio == '' || document.folio == searchFolio;
      const isFactoringRequestIdMatch =
        searchFactoringRequestId == '' ||
        document.requestId == searchFactoringRequestId;
      const isBusinessMatch =
        searchBusiness == 'all' ||
        document.businessIdentifier == searchBusiness;
      return (
        isStakeholderMatch &&
        isFolioMatch &&
        isFactoringRequestIdMatch &&
        isBusinessMatch
      );
    });
    setFilteredDocuments(newFilteredDocuments);
  };

  useEffect(() => {
    if (suggestions.length === 0) {
      showAlert(dispatch, 'warning', 'No hay documentos disponibles.');
    }
    setFilteredSuggestions(suggestions);
  }, [suggestions]);

  return (
    <Dialog maxWidth="md" fullWidth open={open}>
      <DialogTitle>
        <HeaderWithActions
          title="Seleccionar documentos"
          variant={'h6'}
          type="subHeader"
          item={
            <GlobalSearcher
              filters={filters}
              triggerSearch={() => filterDocuments()}
            />
          }
        />
      </DialogTitle>

      <DialogContent>
        {documents.length > MAX_SELECTED_DOCUMENTS && (
          <AlertBanner
            severity="warning"
            title="Limite de documentos"
            message={`Solo puedes seleccionar hasta ${MAX_SELECTED_DOCUMENTS} documentos a la vez. Has seleccionado ${documents.length} documentos. Por favor, deselecciona algunos documentos para continuar.`}
            sx={{ mb: 2 }}
          />
        )}
        <EnhancedTable
          dataHeaders={[
            { key: 'requestType', label: 'Tipo', type: 'text' },
            {
              key: 'requestId',
              label: 'Solicitud',
              type: 'numeric-id',
            },
            { key: 'folio', label: 'Folio' },
            { key: 'businessName', label: 'Cliente' },
            { key: 'stakeholderName', label: 'Deudor' },
            { key: 'amount', label: 'Monto', type: 'money' },
            { key: 'paymentDate', label: 'Fecha vencimiento', type: 'date' },
          ]}
          data={filteredDocuments}
          selected={documents}
          setSelected={setDocuments}
          canSelectAll={true}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={() => setOpen(false)} color="secondary">
          Salir
        </CustomButton>
        <CustomButton
          onClick={() => handleConfirm()}
          color="primary"
          disabled={
            documents.length === 0 || documents.length > MAX_SELECTED_DOCUMENTS
          }
        >
          Confirmar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default MultiResellDocumentSelector;
